/* lisen-nedtaelling.js  (Lone, 11. okt. 2026)

   Uret i tilbudsfeltet paa tilbuddets sidste dag.
   Markup og sluttidspunkt kommer fra snippets/lisen-tilbud.liquid.

   Sluttidspunktet staar i data-slut som et absolut sekundtal, regnet i
   Shopify i butikkens tidszone. Browseren regner altsaa ikke selv ud hvad
   "midnat" er - saa ville en kunde i London se en time for meget.

   Uden JavaScript, eller hvis tiden allerede er gaaet, bliver den
   serverskrevne saetning staaende: "Sidste chance - slutter ved midnat".
   Derfor bygges boksene foerst, naar vi ved der er tid tilbage. */
(function () {
  function start(el) {
    if (!el || el.getAttribute('data-klar')) return;
    var slut = parseInt(el.getAttribute('data-slut'), 10) * 1000;
    if (!slut || slut - Date.now() <= 0) return;
    el.setAttribute('data-klar', '1');

    var tal = {};
    el.textContent = '';
    el.classList.add('er-ur');

    var lab = document.createElement('span');
    lab.className = 'lisen-tilbud__ur-tekst';
    lab.textContent = 'Sidste chance';
    el.appendChild(lab);

    var raekke = document.createElement('span');
    raekke.className = 'lisen-tilbud__ur-tal';
    [['t', 'timer'], ['m', 'min'], ['s', 'sek']].forEach(function (f) {
      var boks = document.createElement('span');
      boks.className = 'lisen-tilbud__ur-boks';
      var b = document.createElement('b');
      var i = document.createElement('i');
      i.textContent = f[1];
      boks.appendChild(b);
      boks.appendChild(i);
      raekke.appendChild(boks);
      tal[f[0]] = b;
    });
    el.appendChild(raekke);

    function to(n) { return (n < 10 ? '0' : '') + n; }

    function tegn() {
      var rest = slut - Date.now();
      if (rest <= 0) {
        el.classList.remove('er-ur');
        el.textContent = 'Tilbuddet er slut';
        return false;
      }
      var s = Math.floor(rest / 1000);
      var t = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      tal.t.textContent = to(t);
      tal.m.textContent = to(m);
      tal.s.textContent = to(s % 60);
      el.setAttribute('aria-label', 'Tilbuddet slutter om ' + t + ' timer og ' + m + ' minutter');
      return true;
    }

    if (tegn()) {
      var id = setInterval(function () { if (!tegn()) { clearInterval(id); } }, 1000);
    }
  }

  function skan() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.lisen-tilbud__nedtaelling[data-slut]'),
      start
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skan);
  } else {
    skan();
  }
  document.addEventListener('shopify:section:load', skan);
})();